module.exports = __webpack_public_path__ + "static/media/terminal.0eef5b07.png";